import { createApp } from 'vue';
import EmbedBuilderModal from './EmbedBuilderModal.vue';

if (document.querySelector('#embed-builder-app')) {
  const app = createApp(EmbedBuilderModal);
  app.mount('#embed-builder-app');
}
